<template>
  <div class="edit-module-content-main">
    <div class="edit-editor-title">
      <div class="edit-back" @click="back">
        <i class="iconfont iconchevron-left"></i>返回
      </div>
      <div class="edit-module-name" :class="[currentInfo.data && currentInfo.data.id ? 'pointer' : 'default']"
           @click="currentInfo.data && currentInfo.data.id && editModuleTitle()">
        <span class="text-overflow">{{title || cvDetail.submodule_info[`${currentInfo.type}_title`] || '作品集'}}</span>
        <i style="color: #C2C2C2;" class="pointer iconfont iconedit-" @click="editModuleTitle"
           v-if="showEditModuleTitle() || isMentorEditor"></i>
      </div>
      <button class="edit-module-save" @click="debounceSave" :disabled="!formData.qrcode">保存</button>
    </div>
    <opus-form-data
			ref="opusForm" :form-data="formData" :experienceInfos="experienceInfos"
			@updateFormData="updateFormData" @deleteExperience="deleteExperience"
		/>
  </div>
</template>
<script>
	import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
	import moment from 'moment'
	import opusFormData from '@/components/editor/opus-form-data'
	import textEditor from './text-editor'
	import richText from '@/components/base/richText'
	import rules from '@/assets/json/rules'
	import cvAuxiliary from './cv-auxiliary'
	import { cvMixin } from '../../../../../assets/js/mixins'
	import editorModule from '../../../../../assets/json/editor-module.json'
	import api from '../../../../../api'
  import { setEditNumLocalStorage, debounce, dataURLtoBlob, blobToFile } from '@/assets/js/util'


  const oss = require('ali-oss');
  let ossTimeName = null //oss定时器
  import { uuid } from 'vue-uuid';

	export default {
		name: 'opusBaseModuleForm',
		mixins: [ cvMixin ],
		data () {
			return {
				debounceSave: null,
				isSave: false,
				title: '', // 模块标题，只在修改标题后使用
				oldFormData: {},
				degreeData: {},
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvToken', 'cvInfo', 'editModuleData' ]),
			...mapState('cvs', [ 'cv', 'editorCvToken', 'highlightShow' ]),
			...mapState('editor', [ 'cvDetail', 'currentInfo', 'backUpInfo', 'edus', 'orgs', 'works', 'checkCloseEditModule', 'opus' ]),
			...mapState('experience', [ 'experienceList' ]),
      ...mapGetters('experience', [ 'hasExperienceList' ]),
			...mapState('global', [ 'ossBeaseOptions' ]),
			...mapState('me', [ 'personInfo' ]),
			isMembership(){
				return this.personInfo.is_membership
			},
			// 当前简历里面的 opus 的经历
			experienceInfos () {
				let { type } = this.currentInfo
				return this[type]
			},
			// 当前编辑的模块经历库里面的内容
			experience () {
				return this.submodule_info.opus_ids
			},
			isMentorEditor () {
				return window.location.href.includes('mentor')
			}
		},
		components: {
			richText,
			textEditor,
			opusFormData,
			cvAuxiliary
		},
		watch: {
			checkCloseEditModule: function (state) {
				if (state) {
					this.back()
					//设置是否需要取消当前编辑状态，并返回
					setTimeout(() => {
						this.setCheckCloseEditModule(false)
					}, 10)
				}
			}
		},
		created () {
      this.debounceSave = debounce(this.save, 300)
      this.initOssBease()

      this.oldFormData = { ... this.formData}
    },
    mounted () {
			this.initFormData()
		},
		methods: {
			...mapActions('cvsEditor', [ 'createdOrg', 'editOrg' ]),
			...mapMutations('editor', [ 'setCurrentInfo', 'setModuleData', 'setCheckCloseEditModule', 'onlysetCurrentInfo' ]),
			...mapActions('editor', [ 'updateExperience', 'createExperience', 'createCvDetail', 'updateCvDetail', 'setIsSendRequest' ]),
			...mapMutations('experience', [ 'updateExperienceModule', 'deleteExperienceSelect', 'updateExperienceTitleName' ]),
      ...mapActions('manage', [ 'getMenuList' ]),
      ...mapActions('global', [ 'getOssBeaseOptions']),

			//是否显示标题
			showEditModuleTitle () {
				let isKind = this.cvDetail.basic_info.kind === 'sample' || this.cvDetail.basic_info.kind === 'template'
				return !isKind
			},
			// 获取check时候的title
			getRulesTitle (title, check) {
				for (let i = 0; i < rules.rules.length; i++) {
					if (rules.rules[i].name === title || (check && check.name === rules.rules[i].name)) {
						return rules.rules[i].title
					}
				}
				return '提示'
			},
			// 保存
			async save () {
				setEditNumLocalStorage()
				let { id, mentor_id } = this.formData
				if(!this.isMembership){
					this.$message.error("该功能为会员专享");
					// 买会员
					this.buyMember()
					return
				}
				if (mentor_id && this.isMentorEditor) {
					this.experienceChange('update')
				} else if (this.formData.id) {
					if (this.contrastInitData(this.formData, this.oldFormData)) {
						this.experienceChange('update')
					} else {
						// 如果和编辑时的 id 一致，就直接关闭窗口
						if (this.formData.id === this.backUpInfo.data.id) {
							this.resetEditState()
						} else {
							this.updateCvDetail({ ...this.formData, saveModule: true })
						}
					}
				} else {
					this.experienceChange('create')
				}
      },
      // 更新或者创建经历
			async experienceChange (operation) {
				let valid = this.$refs['opusForm'].formValidate()
				if (!valid) return false
				let { type } = this.currentInfo
				let res = {}
				let payload = {
					...this.formData,
					lang: this.cvDetail.basic_info.lang
        }
        if(this.formData.qrcode.includes('data:image/')){
          let qrcodeName = `${uuid.v1()}.jpg`
          let qrcodeUrl = this.formData.qrcode
          let ossRes = {};
          let store = await oss(this.ossBeaseOptions);

          //调用
          var blob = dataURLtoBlob(qrcodeUrl);
          var fileData = blobToFile(blob, qrcodeName);
          try {
            ossRes = await store.put(`cv/opus/${qrcodeName}`, fileData)
          } catch (error) {
            this.$message.error('图片上传失败');
            return false;
          }
          if (ossRes.res.statusCode !== 200) {
            this.$message.error('图片上传失败');
            return false;
          }
          payload.qrcode = ossRes.url;
        }

				// 编辑
				if (operation === 'update') {
					res = await this.updateExperience({ type, payload })
					if (res.code === 1000) {
						this.cvDetailChange(res.data[type])
					}
				} else if (operation === 'create') {
					let currentInfoOperation = ''
					//如果进入时是编辑，但是拒绝同步，直接更新
					if (this.currentInfo.operation === 'edit') {
						currentInfoOperation = 'add'
					}
					delete payload.id
					res = await this.createExperience({ type, payload })
					if (res.code === 1000) {
						this.cvDetailChange(res.data[type], currentInfoOperation)
					} else if (res.code === 80143) {
						// 显示超出模块最大限制
						this.showModuleMaxTips()
					}
				}
			},
			// 更新或者创建简历
			async cvDetailChange (data, currentInfoOperation) {
				let { type, operation } = this.currentInfo
				let { submodule_info, basic_info, format_info, basic_info: { kind }, submodule_info: { sections_position } } = this.cvDetail
				let ids = submodule_info[`${ type }_ids`] || []
				let infos = JSON.parse(JSON.stringify(this.experienceInfos))
				let position = JSON.parse(JSON.stringify(sections_position))
				const isCreate = kind === 'template' || kind === 'sample'
				// 找到简历中当前 id 所在位置
				const infoIndex = ids.findIndex(item => item === this.formData.id)
				// 判断当前经历是需要替换 id 还是 往 ids 里面push
				const replace = this.formData.id !== this.backUpInfo.data.id || this.formData.kind === 'sample' || infoIndex > -1
				// 寻找当前模块是否在sections_position中
				const moduleIndex = sections_position.findIndex(item => item.type === type)
				let res = {}
				// 如果当前简历里面没有此模块，则往section_positions里面push当前模块
				if (moduleIndex === -1) {
					position.push({
						type,
						info_ids: [],
						id: null
					})
				}
				replace ? ids[infoIndex] = data.id : ids = [ ...ids, data.id ]
				let payload = {
					submodule_info: {
						...submodule_info,
						sections_position: position,
						[`${ type }_ids`]: Array.from(new Set(ids)).filter(item => !!item)
					},
					operation_type: isCreate ? '' : 'update_submodule_info'
				}
				console.log('isCreate=>>>', isCreate)
				if (window.location.href.includes('mentor')) {
					// 导师编辑只更新简历时间，第一版导师不可在简历里面添加内容
					await this.updateCvDetail({ operation_type: 'touch' })
        }
				if (isCreate) {
					payload = { ...payload, basic_info: { ...basic_info }, format_info }
					res = await this.createCvDetail({
						payload,
					})
				} else {
					res = await this.updateCvDetail({ ...payload, saveModule: true })
				}

				if (res.code === 1000) {
					if (operation === 'module' || operation === 'add') {
						infos[infos.length - 1] = data
					} else if (replace) {
						const index = infos.findIndex(item => item.id === this.backUpInfo.data.id)
						infos[index] = data
					} else {
						infos = [ ...infos, data ]
					}
					//同步数据
					this.setModuleData({ type, info: infos })

					//更新经历库模块信息
					// this.updateExperienceModule({
					// 	key: type,
					// 	info: data,
					// 	operation: currentInfoOperation || operation,
					// 	title: this.title || this.currentInfo.title,
					// 	updateBackUp: true,
					// })
					//整理模块管理模块选中状态
					this.getMenuList()
					//重置编辑模块默认数据
					this.resetEditState()
					this.setDealCheck(true)
					if (this.saveFormDataByDialog) {
						this.saveFormDataByDialog()
						this.setFormDataFn(null)
						// commit('setFormDataFn', null)
					}
				}
			},
			// 修改模块标题
			async editModuleTitle () {
				//判断是否为导师页面
				let pathFirstWord = this.$route.path.substr(1, 6)
				console.log(pathFirstWord, 'pathFirstWord')
				if (pathFirstWord === 'mentor') {
					console.log(123213)
				} else {
					console.log(456564)
				}
				// console.log(456564)

				let { type, operation } = this.currentInfo
				// if (operation !== 'edit') {
				// 	this.$message.error('请先保存模块')
				// 	return false
				// }
				let { submodule_info } = this.cvDetail
				const alertData = {
					...this.alertData,
					messageTitle: '修改模块名称',
					inputData: {
						show: true,
						length: 15,
						value: submodule_info[`${ type }_title`],
						showLength: true,
						placeholder: '请输入模块名称'
					},
					cancel: close => {
						close()
					},
					confirm: async (close, value) => {
						let payload = {
							submodule_info: {
								[`${ type }_title`]: value,
							},
							operation_type: 'update_submodule_info'
						}
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('修改成功')
							//更新经历库模块名称
							this.updateExperienceTitleName({ type, title: value })
							//整理模块管理模块选中状态
							this.getMenuList()
						} else {
							this.$message.error(res.message)
						}
					}
				}
				this.setAlertData(alertData)
			},
			// 删除模块
			async deleteExperience () {
				const alertData = {
					...this.alertData,
					messageContent: `
          <p>删除后可以在页面右下角「经历库」内找回</p>
          <p style="color: #FF453E">确定删除本段经历吗?p>
        `,
					confirm: async close => {
						let { data: { id }, type } = this.backUpInfo
						let { submodule_info, basic_info } = this.cvDetail
            let { sections_position } = submodule_info;
						let ids = submodule_info[`${ type }_ids`]
            let infos = [];
            let payload = [];
            if(ids.length === 1){
              payload = {
                operation_type: 'update_submodule_info',
                submodule_info: {
                  [`${ type }_ids`]: [],
                  sections_position: sections_position.filter(item => item.type != type)
                }
              }
            }else {
              infos = this[type].filter(item => item.id !== id)
              payload = {
                operation_type: 'update_submodule_info',
                submodule_info: {
                  [`${ type }_ids`]: ids.filter(i => i !== id)
                }
              }
            }
						
            if(basic_info.kind == 'sample' || basic_info.kind == 'template') {
              this.$message.error('请先编辑简历信息')
              return ;
            }
						//执行删除模块id
						let deleteOpuRes = await api.cvsEditor.deleteOpus(id, {}, {cv_token: this.cvToken});

						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
							close()
							this.$message.success('删除成功')
							this.setModuleData({ type, info: infos })
							//删除经历库某个模块选中状态
							// this.deleteExperienceSelect({ type, id })
							//重置
							this.resetEditState()
						} else {
							this.$message.error(res.message)
						}
					},
					cancel: close => {
						close()
					},
				}
				this.setAlertData(alertData)
			},
			//显示超出模块最大限制
			// showModuleMaxTips () {
			// 	console.log(this.alertData)
			// 	const alertData = {
			// 		...this.alertData,
			// 		messageTitle: '创建失败',
			// 		showCancelButton: false,
			// 		confirmButtonText: '我知道了',
			// 		messageContent: `当前模块下经历数量已达到上限，请打开右侧边栏「经历库」点击「管理」按钮，删除多余经历`,
			// 		confirm: async close => {
			// 			close()
			// 		},
			// 		cancel: close => {
			// 			close()
			// 		},
			// 	}
			// 	this.setAlertData(alertData)
      // },
      // 初始化oss
      initOssBease () {
        this.getOssBeaseOptions()
        //十分钟重新获取一次
        let ossTimeIndex = 10
        ossTimeName = setInterval(() => {
          if (ossTimeIndex <= 0) {
            //清除定时器
            clearInterval(ossTimeName)
            //重新获取oss参数
            this.initOssBease()
          }
          ossTimeIndex -= 1
        }, 60000)
      },
      //更新formdata
      updateFormData(value){
				//只修改信息，不会修改当时的备份
				this.onlysetCurrentInfo({
					...this.currentInfo,
					data: {
						...value
					}
				})
        this.formData = {
					...this.formData,
          ...value
        }
      },
			// 去买会员
			buyMember(){
				this.$store.dispatch('app/setAlertData', {
					show: true,
					type: 'upVip',
					browseType: 'opus'
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
  .edit-module-content-main {
    padding: 0 28px 50px;
    .edu-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edu-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        cursor: pointer;
        .edu-item-select {
          width: 16px;
          height: 16px;
          border: 1px solid #DEDFE1;
          margin-right: 12px;
          text-align: center;
          line-height: 16px;
          &.active {
            .iconfont {
              font-size: 14px;
              margin: auto;
            }
          }
        }
        .iconfont {
          margin-right: 8px;
        }
      }
    }
    .edit-module-name {
      span {
        display: inline-block;
        max-width: 80%;
      }
      i {
        margin-left: 6px;
      }
    }

  }
</style>
